import { EmptyState } from '@neshane/blueberry';

import './MaintenancePage.css';

/**
 * Full-page maintenance screen shown to regular users while
 * MAINTENANCE_MODE is enabled. Mirrors the ui-kit MaintenanceContainer.
 */
export const MaintenancePage = ({ message = null }) => {
    return (
        <div className="page__container maintenance-page">
            <EmptyState
                className="Maintenance"
                iconName="circle-information"
                iconVariant="info"
                title="در حال تعمیرات"
                subtitle={message || 'سرویس در حال حاضر در دسترس نیست. لطفاً بعداً مراجعه کنید.'}
            />
        </div>
    );
};

export default MaintenancePage;
